const listenerMap = new Map();

export function emit(event, ...args) {
  const listeners = listenerMap.get(event);

  if (!listeners) {
    return;
  }

  listeners.forEach((listener) => listener(...args));
}

export function subscribe(event, callback) {
  let listeners = listenerMap.get(event);

  if (!listeners) {
    listeners = new Set();
    listenerMap.set(event, listeners);
  }

  listeners.add(callback);

  return () => listeners.delete(callback);
}
